import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionApi } from '../axios';

export const useSubscriptionFeatures = () => useQuery({
  queryKey: ['subscription', 'features'],
  queryFn: () => subscriptionApi.get('/v1/subscription/features').then((r) => r.data),
  staleTime: 60000,
});

export const useAdminPlans = () => useQuery({
  queryKey: ['subscription', 'admin', 'plans'],
  queryFn: () => subscriptionApi.get('/v1/subscription/admin/plans').then((r) => r.data),
  staleTime: 10000,
});

export const useUpdateAdminPlan = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...patch }) => subscriptionApi.patch(`/v1/subscription/admin/plans/${id}`, patch).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['subscription'] }),
  });
};

export const useSaveAdminFeatures = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ plan_id, features }) => subscriptionApi.post('/v1/subscription/admin/features', { plan_id, features }).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['subscription'] }),
  });
};
